import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import ProductPage from './product/ProductPage';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ProductPage />
  </React.StrictMode>,
);
